import { makeStyles } from '../../../state/hooks';

export default makeStyles()(theme => ({
    root: {
        marginTop: theme.spacing(5),
    },
}));
